import { EMatchingPaymentTicketStatus } from '../../../../types/enums'
import { MatchingFile } from './_models'

export interface ReceiptSplit {
  current: MatchingFile | null
  history: MatchingFile[]
}

/**
 * The backend sends a deposit's receipts current-first, then the ones staff replaced, newest first.
 * A file without the flag (the answer of the first attach) is the current one.
 */
export const splitReceipts = (files?: MatchingFile[] | null): ReceiptSplit => {
  const list = files ?? []

  return {
    current: list.find((f) => f.current !== false) ?? null,
    history: list.filter((f) => f.current === false),
  }
}

const DECISION_STATUSES: string[] = [
  EMatchingPaymentTicketStatus.FILES_VERIFICATION,
  EMatchingPaymentTicketStatus.FILES_AUTO_VERIFICATION,
  EMatchingPaymentTicketStatus.COMPLETED,
  EMatchingPaymentTicketStatus.DECLINED,
  EMatchingPaymentTicketStatus.EXPIRED,
]

/**
 * Where the backend takes a verify/reject: the receipt checks, and a finished deposit (only the file
 * changes). A deposit awaiting payment again answers 422 and keeps the file's status.
 */
export const receiptDecisionOpen = (ticketStatus?: string | null): boolean =>
  ticketStatus != null && DECISION_STATUSES.includes(ticketStatus)
